import getVideoAdTagUrl from 'Utils/video-ad-tag-url';

export const videoAdTagUrl = ({ videoAdOptions }) =>
  getVideoAdTagUrl(videoAdOptions);

export const shownVideoAd = ({ app: { shownVideoAd } }) => shownVideoAd;
